import "./SportStatTypesList.css";

export default function SportStatTypesList() {
  return <div>SportStatTypesList</div>;
}
